import { render } from "./VGPricingCalculator.vue?vue&type=template&id=6ce82c4d&scoped=true"
import script from "./VGPricingCalculator.vue?vue&type=script&lang=js"
export * from "./VGPricingCalculator.vue?vue&type=script&lang=js"

import "./VGPricingCalculator.vue?vue&type=style&index=0&id=6ce82c4d&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce82c4d"]])

export default __exports__